import { CompanyTitledPage } from "../../TitledPage";

import { SAMPLE_CUSTOMER_LIST, SAMPLE_CUSTOMER_SEND_GROUP_LIST, SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST, SAMPLE_CUSTOMER_SHOP_LIST } from "../../../common/SampleData";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import Table from '@mui/material/Table';
import TableHead from "@mui/material/TableHead";
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { CompanyPartHeader } from "../../../components/PartHeader";
import { useLocation, useNavigate } from "react-router-dom";

import { grey } from "@mui/material/colors";
import { compareDataByShopId } from "../../../utils/customerSendGroup";
import DeleteCustomerSendGroupDialog from "../../../components/CustomerSendGroupDeleteDialog";

import Dialog from "@mui/material/Dialog";

import { yellow } from "@mui/material/colors";
import { useState } from "react";

import { SYSTEM_PATH_COMPANY } from "../../../App";

const infoTableCellSx = {
  fontSize: 18
}

const tableHeadCellSx = {backgroundColor: grey[100]}

const getCustomerSendGroupEditLocationState = (customerSendGroupId) => ({
  customerSendGroupId: customerSendGroupId,
})

function CustomerSendGroupMemberShopTable ({shopList, onClickDeleteMemberShop}) {

  const getShopData = (customerId, shopId) => {
    let customerData = SAMPLE_CUSTOMER_LIST.find((data) => customerId === data.customer_id);
    let shopData = SAMPLE_CUSTOMER_SHOP_LIST.find((data) => customerId === data.customer_id && shopId === data.shop_id);

    return {
      customer_id: customerData.customer_id,
      customer_name: customerData.name,
      shop_id: shopData.shop_id,
      shop_name: shopData.name,
      fax: shopData.fax,
      email: shopData.email
    }
  }
  
  const shopDataList = shopList.map((s_data) => getShopData(s_data.customer_id, s_data.shop_id));

  

  if (shopDataList.length > 0) {
    return (
      <TableContainer component={Box}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={tableHeadCellSx}>取引先名</TableCell>
              <TableCell sx={tableHeadCellSx}>店舗名</TableCell>
              <TableCell sx={tableHeadCellSx}>FAX番号</TableCell>
              <TableCell sx={tableHeadCellSx}>メールアドレス</TableCell>
              <TableCell sx={tableHeadCellSx}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              shopDataList.map((data, i) => (
                <TableRow key={i}>                     
                  <TableCell sx={infoTableCellSx}>
                    {data.customer_name}
                  </TableCell>
                  <TableCell sx={infoTableCellSx}>
                    {data.shop_name}
                  </TableCell>
                  <TableCell sx={infoTableCellSx}>
                    {data.fax}
                  </TableCell>
                  <TableCell sx={infoTableCellSx}>
                    {data.email}
                  </TableCell>
                  <TableCell sx={{textAlign: "right"}}>
                    <Button variant="outlined" color="error" onClick={onClickDeleteMemberShop(data)}>削除</Button>
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  return (
    <Typography>店舗が登録されていません</Typography>
  )  
}

// 取引先送信グループ所属店舗削除ダイアログ
function DeleteMemberShopDialog({open, onCloseDialog, customerSendGroupData, memberShopData}) {

  const onClickDelete = (event) => {
    deleteMemberShop(customerSendGroupData, memberShopData);
    onCloseDialog(event);
  }

  const onClickCancel = (event) => {
    onCloseDialog(event);
  }

  const deleteMemberShop = (customerSendGroupData, memberShopData) => {

    SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST
      .filter((data) => (
        data.customer_send_group_id === customerSendGroupData.customer_send_group_id
        && data.customer_id === memberShopData.customer_id
        && data.shop_id === memberShopData.shop_id
      )).forEach((data) => data.delete_flag = true)
    
    alert(`取引先送信グループ ${customerSendGroupData.name} から次の店舗を削除しました。\n取引先名: ${memberShopData.customer_name}\n店舗名: ${memberShopData.shop_name}`);
  }

  return(
    <Dialog open={open} onClose={onClickCancel}>
      <Box padding={2} minWidth={400}>
        <Typography fontSize={20} fontWeight={700}>取引先送信グループ所属店舗削除</Typography>
        <Box marginTop={2} marginBottom={1}>
          <Typography>以下の店舗を取引先送信グループから削除します。</Typography>
          <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
            <Typography fontSize={20}>取引先送信グループ:&nbsp;{customerSendGroupData ? customerSendGroupData.name : ""}</Typography>
            <Typography fontSize={20}>取引先名:&nbsp;{memberShopData ? memberShopData.customer_name : ""}</Typography>
            <Typography fontSize={20}>店舗名:&nbsp;{memberShopData ? memberShopData.shop_name : ""}</Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs textAlign='center'>
            <Button
              variant="contained"
              color='error'
              onClick={onClickDelete}
            >
              削除
            </Button>
          </Grid>
          <Grid item xs textAlign='center'>
            <Button variant="outlined" onClick={onClickCancel}>戻る</Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  )
}

// 取引先送信グループ店舗一覧
export default function CustomerSendGroupMemberShopsPage() {
  
  const location = useLocation()
  const navigate = useNavigate()
  const customerSendGroupId = location.state.customerSendGroupId

  const [dialogMode, setDialogMode] = useState(-1);
  const [selectedMemberShopData, setSelectedMemberShopData] = useState(null);

  const customerSendGroupData = SAMPLE_CUSTOMER_SEND_GROUP_LIST.find((data) => data.customer_send_group_id === customerSendGroupId);

  const shopList
    = SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST
        .filter((data) => data.customer_send_group_id === customerSendGroupId && !data.delete_flag)
        .sort(compareDataByShopId);

  const onClickReturnCustomerSendGroupList = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/customer_send_group_list");
  }

  const onClickCustomerSendGroupEdit = (customerSendGroupId) => (event) => {
    navigate(
      SYSTEM_PATH_COMPANY + "/customer_send_group_edit",
      {state: getCustomerSendGroupEditLocationState(customerSendGroupId)}
    );
  }

  const onClickDeleteGroup = (event) => {
    setDialogMode(0);
  }

  const onClickDeleteMemberShop = (memberShopData) => (event) => {
    setSelectedMemberShopData(memberShopData)
    setDialogMode(1);
  }

  const onCloseDeleteGroupDialog = (event, isDeleted) => {
    setDialogMode(-1);
    if (isDeleted) {
      navigate(SYSTEM_PATH_COMPANY + "/customer_send_group_list");
    }
  }

  const onCloseDeleteMemberShopDialog = (event, isDeleted) => {
    setDialogMode(-1);
    if (isDeleted) {
      navigate(SYSTEM_PATH_COMPANY + "/customer_send_group_list");
    }
  }

  return (
    <CompanyTitledPage title="取引先送信グループ所属店舗一覧">
      <Typography>
        取引先送信グループID : {customerSendGroupData.customer_send_group_id}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography fontWeight="bold" fontSize={30}>
            {customerSendGroupData.name}
          </Typography>
        </Grid>
        <Grid item xs='auto'>
          <Button variant="outlined" onClick={onClickReturnCustomerSendGroupList}>取引先送信グループ一覧に戻る</Button>
        </Grid>        
      </Grid>

      <CompanyPartHeader>        
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>店舗一覧</Typography>
          </Grid>
          <Grid item xs='auto'>
            <Button variant="outlined" onClick={onClickCustomerSendGroupEdit(customerSendGroupId)}>所属店舗編集</Button>
          </Grid>
          <Grid item xs='auto'>
            <Button variant="outlined" color="error" onClick={onClickDeleteGroup}>店舗グループ削除</Button>
          </Grid>    
        </Grid>
      </CompanyPartHeader>

      <CustomerSendGroupMemberShopTable shopList={shopList} onClickDeleteMemberShop={onClickDeleteMemberShop} />

      <DeleteCustomerSendGroupDialog open={dialogMode === 0} onCloseDialog={onCloseDeleteGroupDialog} customerSendGroupData={customerSendGroupData}/>
      <DeleteMemberShopDialog open={dialogMode === 1} customerSendGroupData={customerSendGroupData} onCloseDialog={onCloseDeleteMemberShopDialog} memberShopData={selectedMemberShopData} />
    </CompanyTitledPage>
  );
}
